import React from "react";
import {
  Container,
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormInput,
  FormSelect,
  FormTextarea,
  FormCheckbox,
  Button,
} from "shards-react";
import { Link } from "react-router-dom";
import TableRow from "../layout/TableRow";
import TableColumnRow from "../layout/TableColumnRow";
import { FcApproval } from "react-icons/fc";
import { FcAcceptDatabase, FcDataConfiguration, FcPlus } from "react-icons/fc";
import ProjectDataService from "../../services/project.service";
import ProjectStructureDataService from "../../services/projectStructure.service";
import TempProjectFileDataService from "../../services/tempProjectFile.service";
import ProcessFileService from "../../services/processFile.service";
import FunctionDataService from "../../services/function.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import nav_store, {
  types as nav_types,
  actions as nav_actions,
} from "../../_stores/sidenav.store";
import { actions as AppActions } from "../../_stores/app.store";
import Select from 'react-select';
import { validateFileSize } from '../util/validate';

const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";
const SPAIN = process.env.REACT_APP_MARKET === "SPAIN";
const INDIA = process.env.REACT_APP_MARKET === "INDIA";
const EGYPT = process.env.REACT_APP_MARKET === "EGYPT";

class CreateProjectStructure extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectDetails: "",
      fileType: "",
      fileFormat: "",
      fileFormatId: "",
      projectStructureName: "",
      skipRows: "",
      dataHeaderRow: "",
      mergedCell: "",
      validationColumn: "",
      exceptionKeywords: "",
      sourceTargetColumnMapping: [],
      rows: "",
      columnsRows: "",
      columnsRowsMapping: "",
      headers: "",
      viewTable: false,
      masterTableFields: [],
      rowNoToremove: [],
      file: null,
      supplierName: "",
      supplierLocationRow: "",
      reportTypeRow: "",
      supplierNameRow: "",
      supplierStatmentPeriodRow: "",
      reportPeriodRange: "",
      showSaveBtn: false,
      fileUploaded: false,
      filepath: "",
      transformTextValues: [],
      companyNameInColumns: true,
      companyNameInRows: false,
      companyNameRowsCount: 2,
      isStripType: false,

      separator: "",
      startDate: "",
      endDate: "",
      supplierCode: "",

      startDateData: "",
      endDateData: "",
      supplierCodedata: "",

      showseparator: false,
      showStartDateIndex: false,
      showEndDateIndex: false,
      showSupplierCodeIndex: false,

      showSupplierName: false,
      showSupplierStatmentPeriodRow: false,
      showSkipRows: false,
      shoDataHeaderRow: false,

      fieldCount:false,

      functionsList:[],
      hasHeader: false,
      isMultipleSheet: false,
      multipleSheetName: [],
      fileDateFormat: 'DD/MM/YYYY',

      allColumnsArray: [],
      selectedAllColumnsArray: [],
      selectedAllColumns: '',
      selectedAllReplaceColumns: ''
    };

    // STK_CODE|COMP_CODE|COMP_NAME|PROD_CODE|PROD_NAME|PACK_NAME|PTS|PTR|MRP|HSNCODE|GST|PROD_IUC

    this.onChangeFileType = this.onChangeFileType.bind(this);
    this.onChangefileFormat = this.onChangefileFormat.bind(this);
    this.onChangeProjectStructureName =
      this.onChangeProjectStructureName.bind(this);
    this.colTransformFunctionChange =
      this.colTransformFunctionChange.bind(this);
    this.transFuncParamValChanged = this.transFuncParamValChanged.bind(this);
    this.onChangeSkipRows = this.onChangeSkipRows.bind(this);
    this.onChangeSupplierNameRow = this.onChangeSupplierNameRow.bind(this);
    this.onChangeSupplierStatmentPeriodRow =
      this.onChangeSupplierStatmentPeriodRow.bind(this);
    this.onChangeDataHeaderRow = this.onChangeDataHeaderRow.bind(this);
    this.onChangeMergedColumns = this.onChangeMergedColumns.bind(this);
    this.onChangeValidationColumn = this.onChangeValidationColumn.bind(this);
    this.onChangeExceptionKeywords = this.onChangeExceptionKeywords.bind(this);

    this.onChangeseparator = this.onChangeseparator.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.onChangeSupplierCode = this.onChangeSupplierCode.bind(this);

    this.showTable = this.showTable.bind(this);
    this.clearData = this.clearData.bind(this);
    this.handleAddProjectStructureForm =
      this.handleAddProjectStructureForm.bind(this);
    this.handleUpdateProjectStructureForm =
      this.handleUpdateProjectStructureForm.bind(this);
    this.handleCloneProjectStructureForm =
      this.handleCloneProjectStructureForm.bind(this);
    this.newProjectStructureForm = this.newProjectStructureForm.bind(this);
    this.onChangeCompanyNameInColumns =
      this.onChangeCompanyNameInColumns.bind(this);
    this.onChangeCompanyNameInRows = this.onChangeCompanyNameInRows.bind(this);
    this.onChangeCompanyNameRowsCount =
      this.onChangeCompanyNameRowsCount.bind(this);
    this.viewOriginalFile = this.viewOriginalFile.bind(this);
    this.onChangeIsStripType = this.onChangeIsStripType.bind(this);
    this.onChangeHasHeader = this.onChangeHasHeader.bind(this);

    this.onChangeStartIndex = this.onChangeStartIndex.bind(this);
    this.onChangeTotalIndex = this.onChangeTotalIndex.bind(this);
    this.onChangeisMultipleSheet = this.onChangeisMultipleSheet.bind(this);
    this.onChangeFileDateFormat = this.onChangeFileDateFormat.bind(this);
    this.onChangeSelectedAllColumns = this.onChangeSelectedAllColumns.bind(this);
    this.handleSelectedAllColumnsArrayChange = this.handleSelectedAllColumnsArrayChange.bind(this);
    this.onChangeSelectedAllReplaceColumns = this.onChangeSelectedAllReplaceColumns.bind(this);

    this.addAdditionalField = this.addAdditionalField.bind(this);
  }

  componentDidMount() {
    this.retrieveFunctionDetails();
    this.retrieveProjectDetails();
    if (this.props.projectStructureId) this.retrieveProjectStructureDetails();
  }

  componentDidUpdate(prevProps) {
    if (this.props.projectId != prevProps.projectId)
      this.retrieveProjectDetails();
  }

  retrieveFunctionDetails() {
    FunctionDataService.getAll().then((response) => {
      var fnDtls = response.data.data;
      this.setState({
        functionsList: fnDtls,
      });
    });
  }

  retrieveProjectDetails() {
    ProjectDataService.get(this.props.projectId).then((response) => {
      this.setState({
        projectDetails: response.data.data,
      });
    });
  }

  addAdditionalItem() {
    console.log('addAdditionalItem.clicked');
    const { masterTableFields, masterTableFieldInitial, masterTableFieldMissingInitial } = this.state;
    if(masterTableFieldMissingInitial.length > 0){
      const newAddItem = masterTableFieldMissingInitial[0];
      this.setState({
        masterTableFieldInitial: [...masterTableFieldInitial, newAddItem],
        masterTableFieldMissingInitial: masterTableFieldMissingInitial.slice(1)
      }, () => {
        // console.log('masterTableFields.masterTableFieldInitial.after', this.state.masterTableFieldInitial);
        // console.log('masterTableFields.masterTableFieldMissingInitial.after', this.state.masterTableFieldMissingInitial);
      });
    }
  }

  addAdditionalField(e, field_name) {
    const { masterTableFields, masterTableFieldInitial } = this.state;
    
    const newField = {
      //_id: Date.now().toString(),
      parameterName: "ColumnList",
      source: "FieldName",
      dataType: "String",
      sourceField: "", // Example value
    };
    
    const fieldColArr = masterTableFieldInitial.map((stc) => {
      if (stc.fieldName === field_name) {
        if (stc.transformFunction) {
          if (
            stc.transformFunction.parameters &&
            stc.transformFunction.parameters.length
          ) {
            
            // Separate "source: CustomValue" parameter and other parameters
            const otherParameters = stc.transformFunction.parameters.filter(param => param.source !== "CustomValue");
            const customValueParameter = stc.transformFunction.parameters.find(param => param.source === "CustomValue");
            
            const updatedParameters = [...otherParameters];
            updatedParameters.push(newField);

            // Add "source: CustomValue" parameter at the end
            if (customValueParameter) {
                updatedParameters.push(customValueParameter);
            }

            // Update the parameters array
            stc.transformFunction.parameters = updatedParameters;

            //stc.transformFunction.parameters = [...stc.transformFunction.parameters, newField];
            return stc;
          }
          return stc;
        }
        return stc;
      }
      return stc;
    });

    
    this.setState({
      masterTableFieldInitial: fieldColArr,
    }, () => {
      // console.log('masterTableFields.masterTableFields.after', this.state.masterTableFields);
      // console.log('masterTableFields.masterTableFieldMissingInitial.after', this.state.masterTableFieldMissingInitial);
    });
  }

  viewOriginalFile(file, runtype) {
    const { fileName } = this.state;
    let finalFileName = fileName;
    if (file) {
      finalFileName = file.name;
    }
    if (finalFileName) {
      this.setState({ fileName: finalFileName });

      AppActions.setLoading(true);
      const { sourceTargetColumnMapping } = this.state;

      let state = { ...this.state };
      delete state.masterTableFields;
      delete state.projectStructureList;
      delete state.supplierFilteredList;
      delete state.supplierList;
      state.runtype = runtype;

      console.log(
        "viewOriginalFile sourceTargetColumnMapping",
        sourceTargetColumnMapping
      );

      ProcessFileService.viewOriginalFile({
        state: state,
        fileName: finalFileName,
        projectId: this.props.projectId,
      }).then((response) => {
        AppActions.setLoading(false);

        if (sourceTargetColumnMapping.length > 0) {
          if (response.data && response.data.output) {
            this.setState({
              rows: response.data.output,
              headers: response.data.output.headerData || [],
              fileUploaded: true,
              supplierName: response.data.output.supplierName,
              reportPeriodRange: response.data.output.dateRange,
            });
          }
        } else {
          if (response.data && response.data.output) {
            this.setState({
              headers: response.data.output.headerData || [],
              fileUploaded: true,
              supplierName: response.data.output.supplierName,
              reportPeriodRange: response.data.output.dateRange,
            });
          }
        }

        this.showTable();
      });
    } else {
      console.error("No File Name Provided");
    }
  }

  retrieveProjectStructureDetails() {
    //alert();
    ProjectStructureDataService.get(this.props.projectStructureId).then(
      (response) => {
        var projectStructureDetails = response.data.data;

        let masterTableFields = projectStructureDetails.sourceTargetColumnMapping;
        let masterTableFieldInitial = [];
        let masterTableFieldMissingInitial = [];
        masterTableFields && masterTableFields.map((mitem,mindex) => {
          if(mitem.apiKey && mitem.apiKey.replace('Additional_Column_', '') > 3 && !mitem.target) {
            masterTableFieldMissingInitial.push(mitem);
            return;
          } else {
            masterTableFieldInitial.push(mitem);
          };
        });
        console.log('masterTableFields.masterTableFieldInitial', masterTableFieldInitial);

        this.setState({
          id: projectStructureDetails.id,
          projectStructureName: projectStructureDetails.projectStructureName,
          fileType: projectStructureDetails.fileType,
          fileFormat: projectStructureDetails.fileFormat,
          skipRows: projectStructureDetails.skipRows,
          dataHeaderRow: projectStructureDetails.dataHeaderRow,
          mergedCell: projectStructureDetails.mergedCell,
          validationColumn: projectStructureDetails.validationColumn,
          exceptionKeywords: projectStructureDetails.exceptionKeywords,
          separator: projectStructureDetails.separator,
          startDate: projectStructureDetails.startDate,
          endDate: projectStructureDetails.endDate,
          supplierCode: projectStructureDetails.supplierCode,
          supplierNameRow: projectStructureDetails.supplierNameRow,
          supplierStatmentPeriodRow:
            projectStructureDetails.supplierStatmentPeriodRow,
          fileName: projectStructureDetails.file,
          supplierName: projectStructureDetails.supplierName,
          reportPeriodRange: projectStructureDetails.reportPeriodRange,
          masterTableFields: projectStructureDetails.sourceTargetColumnMapping,
          masterTableFieldInitial: masterTableFieldInitial,
          masterTableFieldMissingInitial: masterTableFieldMissingInitial,
          fileFormatId: projectStructureDetails.fileFormatId,
          companyNameInColumns: projectStructureDetails.companyNameInColumns,
          companyNameInRows: projectStructureDetails.companyNameInRows || false,
          isStripType: projectStructureDetails.isStripType || false,
          companyNameRowsCount:
            projectStructureDetails.companyNameRowsCount || 2,
          sourceTargetColumnMapping:
            projectStructureDetails.sourceTargetColumnMapping,
          hasHeader: projectStructureDetails.hasHeader,
          fileDateFormat: projectStructureDetails.fileDateFormat,
          allColumnsArray: this.transformFields(projectStructureDetails.sourceTargetColumnMapping),
          selectedAllColumnsArray: projectStructureDetails.selectedAllColumnsArray,
          selectedAllColumns: projectStructureDetails.selectedAllColumns,
          selectedAllReplaceColumns: projectStructureDetails.selectedAllReplaceColumns,
        });

        if (projectStructureDetails.fileType === "textFile") {
          if (projectStructureDetails.hasHeader) {
            this.setState({
              separator: "",
              startDate: "",
              endDate: "",
              supplierCode: "",

              showSupplierName: true,
              showSupplierStatmentPeriodRow: true,
              showSkipRows: true,
              shoDataHeaderRow: true,

              showseparator: false,
              showStartDateIndex: false,
              showEndDateIndex: false,
              showSupplierCodeIndex: false,
            });
          } else {
            this.setState({
              supplierName: "",
              supplierStatmentPeriodRow: "",
              skipRows: "",
              dataHeaderRow: "",

              showSupplierName: false,
              showSupplierStatmentPeriodRow: false,
              showSkipRows: false,
              shoDataHeaderRow: false,

              showseparator: true,
              showStartDateIndex: true,
              showEndDateIndex: true,
              showSupplierCodeIndex: true,
            });
          }
        } else if (
          projectStructureDetails.fileType === "excelFile" ||
          projectStructureDetails.fileType === "csvFile" ||
          projectStructureDetails.fileType === "fixedLength"
        ) {
          this.setState({
            separator: "",
            startDate: "",
            endDate: "",
            supplierCode: "",

            showSupplierName: true,
            showSupplierStatmentPeriodRow: true,
            showSkipRows: true,
            shoDataHeaderRow: true,

            showseparator: false,
            showStartDateIndex: false,
            showEndDateIndex: false,
            showSupplierCodeIndex: false,
            fileType: projectStructureDetails.fileType,
          });
        } else {
          this.setState({
            supplierName: "",
            supplierStatmentPeriodRow: "",
            skipRows: "",
            dataHeaderRow: "",

            showSupplierName: false,
            showSupplierStatmentPeriodRow: false,
            showSkipRows: false,
            shoDataHeaderRow: false,

            separator: "",
            startDate: "",
            endDate: "",
            supplierCode: "",

            showseparator: false,
            showStartDateIndex: false,
            showEndDateIndex: false,
            showSupplierCodeIndex: false,
          });
        }
      }
    );
  }

  onChangeFileType(e) {
    this.setState({
      fileType: e.target.value,
    });

    if (e.target.value === "textFile") {
      if (this.state.hasHeader) {
        this.setState({
          separator: "",
          startDate: "",
          endDate: "",
          supplierCode: "",

          showSupplierName: true,
          showSupplierStatmentPeriodRow: true,
          showSkipRows: true,
          shoDataHeaderRow: true,

          showseparator: false,
          showStartDateIndex: false,
          showEndDateIndex: false,
          showSupplierCodeIndex: false,
        });
      } else {
        this.setState({
          supplierName: "",
          supplierStatmentPeriodRow: "",
          skipRows: "",
          dataHeaderRow: "",

          showSupplierName: false,
          showSupplierStatmentPeriodRow: false,
          showSkipRows: false,
          shoDataHeaderRow: false,

          showseparator: true,
          showStartDateIndex: true,
          showEndDateIndex: true,
          showSupplierCodeIndex: true,
        });
      }
    } else if (e.target.value === "excelFile" || e.target.value === "csvFile") {
      this.setState({
        separator: "",
        startDate: "",
        endDate: "",
        supplierCode: "",

        showSupplierName: true,
        showSupplierStatmentPeriodRow: true,
        showSkipRows: true,
        shoDataHeaderRow: true,

        showseparator: false,
        showStartDateIndex: false,
        showEndDateIndex: false,
        showSupplierCodeIndex: false,
      });
    } else if (
      e.target.value === "fixedLength" ||
      e.target.value === "fixedLength"
    ) {
      this.setState({
        separator: "",
        startDate: "",
        endDate: "",
        supplierCode: "",

        showSupplierName: true,
        showSupplierStatmentPeriodRow: true,
        showSkipRows: true,
        shoDataHeaderRow: true,

        showseparator: false,
        showStartDateIndex: false,
        showEndDateIndex: false,
        showSupplierCodeIndex: false,
      });
    } else {
      this.setState({
        supplierName: "",
        supplierStatmentPeriodRow: "",
        skipRows: "",
        dataHeaderRow: "",

        showSupplierName: false,
        showSupplierStatmentPeriodRow: false,
        showSkipRows: false,
        shoDataHeaderRow: false,

        separator: "",
        startDate: "",
        endDate: "",
        supplierCode: "",

        showseparator: false,
        showStartDateIndex: false,
        showEndDateIndex: false,
        showSupplierCodeIndex: false,
      });
    }
  }

  onChangefileFormat(e) {
    var fileFormat = e.target.value;
    var resultset = [];
    var masterTableFields = [];
    var fileFormatId = "";
    resultset.push(this.state.projectDetails);
    // take out master fields from selected file format
    resultset.filter(function (data) {
      // take out files array
      var fileFormatData = data["files"].filter(function (fileData) {
        return fileData.fileFormat === fileFormat;
      });
      masterTableFields =
        fileFormatData.length && fileFormatData[0].masterTableFields;
      fileFormatId = fileFormatData.length && fileFormatData[0]._id;
      // return masterTableFields;
    });
    const masterTableFieldsArray = masterTableFields.map((mtm, mtx, arr) => ({
      ...mtm,
      transformFunction: null,
      startIndex: 0, // or whatever value you want for startIndex
      endIndex: 0, // or whatever value you want for endIndex
      totalIndex: 0,
    }));

    let masterTableFieldInitial = [];
    let masterTableFieldMissingInitial = [];
    masterTableFields && masterTableFields.map((mitem,mindex) => {
      if(mitem.apiKey && mitem.apiKey.replace('Additional_Column_', '') > 3 && !mitem.target) {
        masterTableFieldMissingInitial.push(mitem);
        return;
      } else {
        masterTableFieldInitial.push(mitem);
      };
    });
    console.log('masterTableFields.masterTableFieldInitial', masterTableFieldInitial);

    console.log('onChangefileFormat.masterTableFieldInitial', masterTableFieldsArray);



    this.setState({
      ...this.state,
      masterTableFields: masterTableFieldsArray,
      masterTableFieldInitial: masterTableFieldInitial,
      masterTableFieldMissingInitial: masterTableFieldMissingInitial,
      fileFormat: fileFormat,
      fileFormatId: fileFormatId,
    });
  }

  onChangeSelectedAllColumns(e) {
    this.setState({
			selectedAllColumns: e.target.value,
		});
  }

  handleSelectedAllColumnsArrayChange(selectedOption) {
    console.log(`handleSelectedAllColumnsArrayChange Option selected:`, selectedOption);
    this.setState({ selectedAllColumnsArray: selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedAllColumnsArray)
    );
  };

  onChangeSelectedAllReplaceColumns(e) {
    this.setState({
			selectedAllReplaceColumns: e.target.value,
		});
  }

  onChangeProjectStructureName(e) {
    this.setState({
      projectStructureName: e.target.value,
    });
  }

  onChangeSkipRows(e) {
    this.setState({
      skipRows: e.target.value,
    });
  }

  onChangeSupplierNameRow(e) {
    this.setState({
      supplierNameRow: e.target.value,
    });
  }

  onChangeSupplierStatmentPeriodRow(e) {
    this.setState({
      supplierStatmentPeriodRow: e.target.value,
    });
  }

  // JavaScript function to transform the array
  transformFields(fields) {
    return fields
        .filter(field => field.apiKey)  // Filter out fields where apiKey is empty
        .map(field => ({
            label: field.fieldName.replace(/_/g, ' ').toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase()), // Title case label
            value: field.apiKey
        }));
  };

  onChangeHasHeader(e) {
    var isTrueSet = e.target.value === "true";
    this.setState({
      hasHeader: isTrueSet,
    });

    if (isTrueSet) {
      this.setState({
        separator: "",
        startDate: "",
        endDate: "",
        supplierCode: "",

        showSupplierName: true,
        showSupplierStatmentPeriodRow: true,
        showSkipRows: true,
        shoDataHeaderRow: true,

        showseparator: false,
        showStartDateIndex: false,
        showEndDateIndex: false,
        showSupplierCodeIndex: false,
      });
    } else {
      this.setState({
        supplierName: "",
        supplierStatmentPeriodRow: "",
        skipRows: "",
        dataHeaderRow: "",

        showSupplierName : false,
        showSupplierStatmentPeriodRow: false,
        showSkipRows: false,
        shoDataHeaderRow: false,

        separator :"",
        startDate: "",
        endDate: "",
        supplierCode: "",
        
        showseparator: false,
        showStartDateIndex: false,
        showEndDateIndex: false,
        showSupplierCodeIndex: false


      });
    }
	}


  onChangefileFormat1(e) {
		var fileFormat = e.target.value;
    var resultset=[];
    var masterTableFields=[];
    var fileFormatId="";
    resultset.push(this.state.projectDetails)
    // take out master fields from selected file format
    resultset.filter(function (data) {  // take out files array
     var fileFormatData = data['files'].filter(function (fileData){
        return fileData.fileFormat === fileFormat;
      })
      masterTableFields = fileFormatData.length && fileFormatData[0].masterTableFields;
      fileFormatId = fileFormatData.length && fileFormatData[0]._id;
     // return masterTableFields;
    });
    this.setState({
      ...this.state,
      masterTableFields: masterTableFields.map((mtm,mtx) => (mtm['transformFunction'] = null, mtm)),
      masterTableFieldInitial: masterTableFields.map((mtm,mtx) => (mtm['transformFunction'] = null, mtm)),
      fileFormat:fileFormat,
      fileFormatId: fileFormatId,
    });
	}

  onChangeProjectStructureName1(e) {
		this.setState({
			projectStructureName: e.target.value,
		});
	}

  onChangeSkipRows1(e) {
		this.setState({
			skipRows: e.target.value,
		});
	}

  onChangeSupplierNameRow1(e) {
		this.setState({
			supplierNameRow: e.target.value,
		});
	}

  onChangeSupplierStatmentPeriodRow1(e) {
		this.setState({
			supplierStatmentPeriodRow: e.target.value,
		});
	}

  onChangeHasHeader1(e) {
    var isTrueSet = (e.target.value === 'true');
		this.setState({
			hasHeader: isTrueSet,
		});

    if(isTrueSet){
      this.setState({
        separator :"",
        startDate: "",
        endDate: "",
        supplierCode: "",

        showSupplierName : true,
        showSupplierStatmentPeriodRow: true,
        showSkipRows: true,
        shoDataHeaderRow: true,
        
        showseparator: false,
        showStartDateIndex: false,
        showEndDateIndex: false,
        showSupplierCodeIndex: false
      });
    } else {
      this.setState({

        supplierName : "",
        supplierStatmentPeriodRow: "",
        skipRows: "",
        dataHeaderRow: "",

        showSupplierName : false,
        showSupplierStatmentPeriodRow: false,
        showSkipRows: false,
        shoDataHeaderRow: false,

        showseparator: true,
        showStartDateIndex: true,
        showEndDateIndex: true,
        showSupplierCodeIndex: true,
      });
    }
  }

  onChangeCompanyNameInColumns(e) {
    var isTrueSet = e.target.value === "true";
    this.setState({
      companyNameInColumns: isTrueSet,
    });
  }

  onChangeCompanyNameInRows(e) {
    var isTrueSet = e.target.value === "true";
    this.setState({
      companyNameInRows: isTrueSet,
    });
  }

  onChangeIsStripType(e) {
    var isTrueSet = e.target.value === "true";
    this.setState({
      isStripType: isTrueSet,
    });
  }

  onChangeFileDateFormat(e) {
    this.setState({
			fileDateFormat: e.target.value,
		});
	}

  onChangeCompanyNameRowsCount(e) {
    this.setState({
      companyNameRowsCount: e.target.value,
    });
  }

  onChangeDataHeaderRow(e) {
    this.setState({
      dataHeaderRow: e.target.value,
    });
  }

  onChangeMergedColumns(e) {
    this.setState({
      mergedCell: e.target.value,
    });
  }

  onChangeValidationColumn(e) {
    this.setState({
      validationColumn: e.target.value,
    });
  }

  onChangeExceptionKeywords(e) {
    this.setState({
      exceptionKeywords: e.target.value,
    });
  }

  onChangeseparator(e) {
    this.setState({
      separator: e.target.value,
    });
  }

  onChangeStartDate(e) {
    this.setState({
      startDate: e.target.value,
    });
  }

  onChangeEndDate(e) {
    this.setState({
      endDate: e.target.value,
    });
  }

  onChangeCompanyNameInColumns(e) {
    var isTrueSet = (e.target.value === 'true');
		this.setState({
			companyNameInColumns: isTrueSet,
		});
	}

  onChangeCompanyNameInRows(e) {
    var isTrueSet = (e.target.value === 'true');
		this.setState({
			companyNameInRows: isTrueSet,
		});
	}

  onChangeIsStripType(e) {
    var isTrueSet = (e.target.value === 'true');
		this.setState({
			isStripType: isTrueSet,
		});
	}

  onChangeCompanyNameRowsCount(e) {
    this.setState({
			companyNameRowsCount: e.target.value,
		});
	}

  onChangeDataHeaderRow(e) {
		this.setState({
			dataHeaderRow: e.target.value,
		});
	}

  onChangeMergedColumns(e) {
		this.setState({
			mergedCell: e.target.value,
		});
	}

  onChangeValidationColumn(e) {
		this.setState({
			validationColumn: e.target.value,
		});
	}

  onChangeExceptionKeywords(e) {
    this.setState({
			exceptionKeywords: e.target.value,
		});
	}

  onChangeisMultipleSheet(e) {
    this.setState({
      isMultipleSheet: e,
    });
  }


  onChangeseparator(e){
    this.setState({
      separator: e.target.value,
  });
}

  onChangeStartDate(e){
    this.setState({
      startDate: e.target.value,
  });
}

  onChangeEndDate(e){
    this.setState({
      endDate: e.target.value,
  });
}

  onChangeSupplierCode(e) {
    this.setState({
      supplierCode: e.target.value,
    });
  }

  getFileExtension(name) {
    const parts = name.split(".");

    if (parts.length > 0) {
      return parts.pop();
    }

    return false;
  }

  isValidExtension(name) {
    let extension = this.getFileExtension(name);
    extension = (extension && extension.toLowerCase()) || "";
    const { fileType } = this.state;
    let result = false;
    if (fileType === "textFile" || fileType === "TEXT File") {
      result = extension === "txt";
    } else if (fileType === "excelFile" || fileType === "EXCEL File") {
      result = extension === "xls" || extension === "xlsx";
    } else if (fileType === "csvFile") {
      result = extension === "csv";
    } else if (fileType === "fixedLength") {
      result =
        extension === "xls" ||
        extension === "xlsx" ||
        extension === "txt" ||
        extension === "csv";
    }
    return result;
  }

  validateFileAttached(file) {
    // let supplierNo = ( (file.name.startsWith('SAS')) || file.name.startsWith('sas')) ?
    //                     file.name.slice(3, 9) :
    //                     (file.name.startsWith('P') || file.name.startsWith('p')) ?
    //                     file.name.slice(1, 7) : '';

    //   console.log('state', this.state);

    //   let projectFileName = this.state.projectFileName;
    //   if(!projectFileName.includes(supplierNo)){
    //     const notify_message =({
    //       type:"error",
    //       message:"Incorrect Supplier Attached"
    //     });
    //     this.notify(notify_message.type,notify_message.message);
    //     return;
    //   }

    let fileType = this.state.fileType;
    let fileExtention = this.getFileExtension(file.name);
    fileExtention = (fileExtention && fileExtention.toLowerCase()) || "";
    if (fileType === "excelFile" || fileType === "EXCEL File") {
      if (fileExtention !== "xls" && fileExtention !== "xlsx") {
        const notify_message = {
          type: "error",
          message: `File type selected is Excel File but attached is an ${
            fileExtention[fileExtention.length - 1]
          }`,
        };
        this.notify(notify_message.type, notify_message.message);
        return;
      }
    } else if (fileType === "csvFile") {
      if (fileExtention !== "csv") {
        const notify_message = {
          type: "error",
          message: `File type selected is CSV File but attached is an ${
            fileExtention[fileExtention.length - 1]
          }`,
        };
        this.notify(notify_message.type, notify_message.message);
        return;
      }
    } else if (fileType === "textFile" || fileType === "TEXT File") {
      if (fileExtention !== "txt") {
        const notify_message = {
          type: "error",
          message: `File type selected is Text File but attached is an ${
            fileExtention[fileExtention.length - 1]
          }`,
        };
        this.notify(notify_message.type, notify_message.message);
        return;
      }
    }

    let fileFormat = this.state.fileFormat;
    console.log("fileFormat", fileFormat);
    if (fileFormat === "Product Master" || fileFormat === "P FILE") {
      if (!(file.name.startsWith("P") || file.name.startsWith("p"))) {
        const notify_message = {
          type: "error",
          message: `File Format is selected is Product Master but attached is different format`,
        };
        this.notify(notify_message.type, notify_message.message);
        return;
      }
    } else if (fileFormat === "SAS Master" || fileFormat === "sas FILE") {
      if (
        !(
          file.name.startsWith("sas") ||
          file.name.startsWith("SAS") ||
          file.name.startsWith("Sas")
        )
      ) {
        const notify_message = {
          type: "error",
          message: `File Format is selected is SAS Master but attached is different format`,
        };
        this.notify(notify_message.type, notify_message.message);
        return;
      }
    }
  }

  readFile(e) {
    const { target } = e;
    let file = null;

    if (target.files && target.files.length > 0) {
      file = target.files[0];

      const isValid = validateFileSize(file);
      if (!isValid) return;

      this.validateFileAttached(file);

      if (!this.isValidExtension(file.name)) {
        const notify_message = {
          type: "error",
          message: "File Extension Incorrect",
        };
        this.notify(notify_message.type, notify_message.message);
        return;
      }
    }

    var data = {
      projectId: this.props.projectId,
      projectStructureName: this.state.projectStructureName,
      fileType: this.state.fileType,
      file: file,
    };
    AppActions.setLoading(true);
    TempProjectFileDataService.create(data).then((response) => {
      AppActions.setLoading(false);
      if (response.data.success) {
        // check for success
        var notify_message = {
          type: "success",
          message: "Project Structure has been created successfully.",
        };
        this.viewOriginalFile(file);
      } else {
        if (response.data.err.message) {
          // fields error
          var notify_message = {
            type: "error",
            message: response.data.err.message,
          };
        } else {
          // mongo error
          var notify_message = {
            type: "error",
            message: "Duplicate Project Structure Name ",
          };
        }
        this.notify(notify_message.type, notify_message.message);
      }
    });

    this.setState({ file: file });
  }

  clearData() {
    localStorage.clear();
    this.setState({
      rows: "",
    });
  }

  showTable() {
    //alert();
    this.setState({
      viewTable: true,
      showSaveBtn: true,
    });
  }

  newProjectStructureForm() {
    this.setState({
      projectStructureName: "",
      fileType: "",
      fileFormat: "",
      fileFormatId: "",
      skipRows: "",
      supplierName: "",
      reportPeriodRange: "",

      separator: "",
      startDate: "",
      endDate: "",
      supplierCode: "",

      dataHeaderRow: "",
      validationColumn: "",
      exceptionKeywords: "",
      sourceTargetColumnMapping: "",
      hasHeader: false,
    });
  }

  handleAddProjectStructureForm() {
    AppActions.setLoading(true);
    const sourceTargetColumnMapping = this.deleteUnselectedColumns();

    var data = {
      projectId: this.props.projectId,
      projectStructureName: this.state.projectStructureName,
      fileType: this.state.fileType,
      fileFormat: this.state.fileFormat,
      fileFormatId: this.state.fileFormatId,
      companyNameInColumns: this.state.companyNameInColumns,
      companyNameInRows: this.state.companyNameInRows,
      isStripType: this.state.isStripType,
      companyNameRowsCount: this.state.companyNameRowsCount,
      supplierNameRow: this.state.supplierNameRow,
      supplierStatmentPeriodRow: this.state.supplierStatmentPeriodRow,
      skipRows: this.state.skipRows,
      dataHeaderRow: this.state.dataHeaderRow,
      mergedCell: this.state.mergedCell,
      validationColumn: this.state.validationColumn,
      exceptionKeywords: this.state.exceptionKeywords,
      separator: this.state.separator,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      supplierCode: this.state.supplierCode,
      file: this.state.file,
      supplierName: this.state.supplierName,
      reportPeriodRange: this.state.reportPeriodRange,
      sourceTargetColumnMapping: sourceTargetColumnMapping,
      hasHeader: this.state.hasHeader,
      fileDateFormat: this.state.fileDateFormat,
      selectedAllColumnsArray: this.state.selectedAllColumnsArray,
      selectedAllColumns: this.state.selectedAllColumns,
      selectedAllReplaceColumns: this.state.selectedAllReplaceColumns,
    };

    ProjectStructureDataService.create(data).then((response) => {
      AppActions.setLoading(false);
      if (response.data.success) {
        // check for success
        this.newProjectStructureForm();
        var notify_message = {
          type: "success",
          message: "Project Structure has been created successfully.",
        };
        nav_actions.setSideNav(nav_store.dispatch, {});
        this.props.redirectToViewProjectStructure(
          "/project/" + this.props.projectId + "/structure",
          notify_message
        );
      } else {
        if (response.data.err.message) {
          // fields error
          var notify_message = {
            type: "error",
            message: response.data.err.message,
          };
        } else {
          // mongo error
          var notify_message = {
            type: "error",
            message: "Duplicate Project Structure Name ",
          };
        }
        this.notify(notify_message.type, notify_message.message);
      }
    });
  }

  handleUpdateProjectStructureForm() {
    AppActions.setLoading(true);
    const sourceTargetColumnMapping = this.deleteUnselectedColumns();

    var data = {
      projectId: this.props.projectId,
      projectStructureName: this.state.projectStructureName,
      fileType: this.state.fileType,
      fileFormat: this.state.fileFormat,
      fileFormatId: this.state.fileFormatId,
      companyNameInColumns: this.state.companyNameInColumns,
      companyNameInRows: this.state.companyNameInRows,
      isStripType: this.state.isStripType,
      companyNameRowsCount: this.state.companyNameRowsCount,
      supplierNameRow: this.state.supplierNameRow,
      supplierStatmentPeriodRow: this.state.supplierStatmentPeriodRow,
      skipRows: this.state.skipRows,
      dataHeaderRow: this.state.dataHeaderRow,
      mergedCell: this.state.mergedCell,
      validationColumn: this.state.validationColumn,
      exceptionKeywords: this.state.exceptionKeywords,
      separator: this.state.separator,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      supplierCode: this.state.supplierCode,
      file: this.state.file,
      fileName: this.state.fileName,
      supplierName: this.state.supplierName,
      reportPeriodRange: this.state.reportPeriodRange,
      sourceTargetColumnMapping: sourceTargetColumnMapping,
      file_Name: this.state.fileName,
      hasHeader: this.state.hasHeader,
      fileDateFormat: this.state.fileDateFormat,
      selectedAllColumnsArray: this.state.selectedAllColumnsArray,
      selectedAllColumns: this.state.selectedAllColumns,
      selectedAllReplaceColumns: this.state.selectedAllReplaceColumns,
    };

    ProjectStructureDataService.update(
      this.props.projectStructureId,
      data
    ).then((response) => {
      AppActions.setLoading(false);
      if (response.data.success) {
        // check for success
        this.newProjectStructureForm();
        var notify_message = {
          type: "success",
          message: "Project Structure has been Updated successfully.",
        };
        nav_actions.setSideNav(nav_store.dispatch, {});
        this.props.redirectToViewProjectStructure(
          "/project/" + this.props.projectId + "/structure",
          notify_message
        );
      } else {
        if (response.data.err.message) {
          // fields error
          var notify_message = {
            type: "error",
            message: response.data.err.message,
          };
        } else {
          // mongo error
          var notify_message = {
            type: "error",
            message: "Duplicate Project Structure Name ",
          };
        }
        this.notify(notify_message.type, notify_message.message);
      }
    });
  }

  handleCloneProjectStructureForm() {
    AppActions.setLoading(true);
    const sourceTargetColumnMapping = this.deleteUnselectedColumns();
    var data = {
      projectId: this.props.projectId,
      projectStructureName: this.state.projectStructureName,
      fileType: this.state.fileType,
      fileFormat: this.state.fileFormat,
      fileFormatId: this.state.fileFormatId,
      companyNameInColumns: this.state.companyNameInColumns,
      companyNameInRows: this.state.companyNameInRows,
      isStripType: this.state.isStripType,
      companyNameRowsCount: this.state.companyNameRowsCount,
      supplierNameRow: this.state.supplierNameRow,
      supplierStatmentPeriodRow: this.state.supplierStatmentPeriodRow,
      skipRows: this.state.skipRows,
      dataHeaderRow: this.state.dataHeaderRow,
      mergedCell: this.state.mergedCell,
      validationColumn: this.state.validationColumn,
      exceptionKeywords: this.state.exceptionKeywords,
      separator: this.state.separator,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      supplierCode: this.state.supplierCode,
      file: this.state.file,
      fileName: this.state.fileName,
      supplierName: this.state.supplierName,
      reportPeriodRange: this.state.reportPeriodRange,
      sourceTargetColumnMapping: sourceTargetColumnMapping,
      hasHeader: this.state.hasHeader,
      fileDateFormat: this.state.fileDateFormat,
      selectedAllColumnsArray: this.state.selectedAllColumnsArray,
      selectedAllColumns: this.state.selectedAllColumns,
      selectedAllReplaceColumns: this.state.selectedAllReplaceColumns,
    };

    ProjectStructureDataService.create(data).then((response) => {
      AppActions.setLoading(false);
      if (response.data.success) {
        // check for success
        this.newProjectStructureForm();
        var notify_message = {
          type: "success",
          message: "Project Structure has been Clone successfully.",
        };
        nav_actions.setSideNav(nav_store.dispatch, {});
        this.props.redirectToViewProjectStructure(
          "/project/" + this.props.projectId + "/structure",
          notify_message
        );
      } else {
        if (response.data.err.message) {
          // fields error
          var notify_message = {
            type: "error",
            message: response.data.err.message,
          };
        } else {
          // mongo error
          if (response.data.err.code === 11000) {
            var notify_message = {
              type: "error",
              message: "Duplicate Project Structure Name.",
            };
          } else if (
            response.data.err.code === "ENOTEMPTY" ||
            response.data.err.code === "ENOENT"
          ) {
            var notify_message = {
              type: "error",
              message: "Please Select file.",
            };
          } else {
            var notify_message = {
              type: "error",
              message: "Error in Cloning.",
            };
          }
        }
        this.notify(notify_message.type, notify_message.message);
      }
    });
  }

  deleteUnselectedColumns() {
    const { sourceTargetColumnMapping, headers, fileType, hasHeader } =
      this.state;
    sourceTargetColumnMapping.map((item) => {
      if (item.target) {
        let targetColumn = item.target;
        if (fileType === "textFile" && !hasHeader) {
          targetColumn = Number(item.target);
          if(SAUDI || EGYPT){
            targetColumn = (item.target);
          }
        }
        if (!headers.includes(targetColumn)) {
          if(!SAUDI || EGYPT){
            delete item.target;
            delete item.source;
          }
        }
      } else {
        delete item.target;
        delete item.source;
      }
    });

    return sourceTargetColumnMapping;
  }

  handleFieldCount(e, name) {
    const { sourceTargetColumnMapping, masterTableFields } = this.state;

    let sourceTargetColumnMappingArray =
      sourceTargetColumnMapping.length > 0
        ? [...sourceTargetColumnMapping]
        : [...masterTableFields];

    sourceTargetColumnMappingArray.map((item) => {
      if (item.fieldName === name) {
        item.checked = item.checked ? !item.checked : true;
      }
    });

    this.setState({
      sourceTargetColumnMapping: sourceTargetColumnMappingArray,
    });
  }

  handleHeaderChange(e) {
    const {
      target: { value, name },
    } = e;

    const { sourceTargetColumnMapping, masterTableFields } = this.state;

    let sourceTargetColumnMappingArray =
      sourceTargetColumnMapping.length > 0
        ? [...sourceTargetColumnMapping]
        : [...masterTableFields];

    sourceTargetColumnMappingArray.map((item) => {
      if (item.fieldName === name) {
        item.source = name;
        item.target = value === "Select Target Field" ? "" : value;
      }
    });

    this.setState({
      sourceTargetColumnMapping: sourceTargetColumnMappingArray,
    });
  }

  colTransformFunctionChange(e, field_name) {
    const {
      target: { value, name },
    } = e;
    const { sourceTargetColumnMapping, masterTableFields } = this.state;

    const fieldColArr = sourceTargetColumnMapping.length
      ? [...sourceTargetColumnMapping]
      : [...masterTableFields];
    const selectedFnDt = this.state.functionsList.find(
      (item) => item.id === value
    );

    if (fieldColArr.length)
      this.setState({
        sourceTargetColumnMapping: fieldColArr.map((itm) =>
          itm.fieldName === field_name
            ? ((itm["transformFunction"] = selectedFnDt), itm)
            : itm
        ),
      });
  }

  transFuncParamValChanged(e, field_name, field_id) {
    const {
      target: { value, name },
    } = e;
    const { sourceTargetColumnMapping } = this.state;
    
    const fieldColArr = sourceTargetColumnMapping.map((stc) => {
      if (stc.fieldName === field_name) {
        if (stc.transformFunction) {
          if (
            stc.transformFunction.parameters &&
            stc.transformFunction.parameters.length
          ) {
            stc.transformFunction.parameters =
              stc.transformFunction.parameters.map((prm) => {
                if (prm._id === field_id) {
                  if (prm.source === "FieldName") prm["sourceField"] = value;
                  if (prm.source === "MasterFieldName") prm["sourceField"] = value;
                  else prm["inputValue"] = value;
                }
                return prm;
              });
            return stc;
          }
          return stc;
        }
        return stc;
      }
      return stc;
    });

    this.setState({ sourceTargetColumnMapping: fieldColArr });
  }

  removeDuplicate(arr, prop) {
    var new_arr = [];
    var lookup = {};
    for (var i in arr) {
      lookup[arr[i][prop]] = arr[i];
    }
    for (i in lookup) {
      new_arr.push(lookup[i]);
    }
    return new_arr;
  }

  onChangeStartIndex(e, field_name) {
    const {
      target: { value, name },
    } = e;

    const { sourceTargetColumnMapping, masterTableFields } = this.state;

    let sourceTargetColumnMappingArray =
      sourceTargetColumnMapping.length > 0
        ? [...sourceTargetColumnMapping]
        : [...masterTableFields];

    sourceTargetColumnMappingArray.map((item) => {
      if (item.fieldName === name) {
        item.source = name;
        //item.target = value === "Select Target Field" ? '' : value;
        item.startIndex = value;
      }
    });

    this.setState({
      sourceTargetColumnMapping: sourceTargetColumnMappingArray,
    });
  }

  onChangeTotalIndex(e, field_name) {
    const {
      target: { value, name },
    } = e;

    const { sourceTargetColumnMapping, masterTableFields } = this.state;

    let sourceTargetColumnMappingArray =
      sourceTargetColumnMapping.length > 0
        ? [...sourceTargetColumnMapping]
        : [...masterTableFields];

    sourceTargetColumnMappingArray.map((item) => {
      if (item.fieldName === name) {
        item.source = name;
        //item.target = value === "Select Target Field" ? '' : value;
        item.totalIndex = value;
      }
    });

    this.setState({
      sourceTargetColumnMapping: sourceTargetColumnMappingArray,
    });
  }

  //this is for showing notification
  notify(type, message) {
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      type: type,
    });
  }

  render() {
    const {
      clearData,
      headers,
      viewTable,
      projectDetails,
      masterTableFields,
      masterTableFieldInitial,
      fileFormatId,
      showSaveBtn,
      fileUploaded,
      fileName,
      file,
      fileType,
      separator,
      startDate,
      endDate,
      supplierCode,
      showseparator,
      showStartDateIndex,
      showEndDateIndex,
      showSupplierCodeIndex,
      showSupplierName,
      showSupplierStatmentPeriodRow,
      showSkipRows,
      shoDataHeaderRow,
      functionsList,
      hasHeader,
      allColumnsArray,
      selectedAllColumnsArray,
      selectedAllColumns,
      selectedAllReplaceColumns,
      // PostsListFour
    } = this.state;

    const {
      projectId,
      projectStructureId,
      cloneText,
      // PostsListFour
    } = this.props;

    const totalRowProcessed =
      this.state.rows &&
      this.state.rows.rowData &&
      this.state.rows.rowData.length > 0
        ? this.state.rows.rowData.length
        : 0 || 0;
    const totalRowCount = this.state.rows.totalRowCount || 0;
    const totalEmptyRowCount = this.state.rows.totalEmptyRowCount || 0;
    const totalErrorRow = this.state.rows.totalErrorRowCount || 0;

    return (
      <div>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">
              {projectStructureId
                ? "Edit Project Structure Definition"
                : "Create New Project Structure Definition1"}
              <Link
                className="btn btn-primary ml-4"
                to={"/project/" + projectId + "/structure"}
              >
                <FcAcceptDatabase /> View All
              </Link>
            </h6>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="">
              <Form>
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="fileType">File Type</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormSelect
                          id="fileType"
                          onChange={this.onChangeFileType}
                          value={this.state.fileType}
                        >
                          <option value="">Select File Type</option>
                          <option value="excelFile">EXCEL File</option>
                          <option value="csvFile">CSV File</option>
                          <option value="textFile">TEXT File</option>
                          <option value="fixedLength">Fixed Length</option>
                        </FormSelect>
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="fileFormat">File Format</label>
                      </Col>
                      <Col className="form-field" md="8">
                        {projectDetails && (
                          <FormSelect
                            id="fileFormat"
                            onChange={this.onChangefileFormat}
                            value={this.state.fileFormat}
                          >
                            <option>Select File Format</option>
                            {projectDetails.files &&
                              projectDetails.files.map((item, index) => {
                                return (
                                  <option key={index} value={item.fileFormat}>
                                    {item.fileFormat}
                                  </option>
                                );
                              })}
                          </FormSelect>
                        )}
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="projectStructureName">
                          Structure Name
                        </label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormInput
                          id="projectStructureName"
                          placeholder="Structure Name"
                          value={this.state.projectStructureName}
                          onChange={this.onChangeProjectStructureName}
                        />
                      </Col>
                    </Row>

                    {showseparator && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="separator">separator</label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInput
                            id="separator"
                            placeholder="separator"
                            value={this.state.separator}
                            onChange={this.onChangeseparator}
                          />
                        </Col>
                      </Row>
                    )}

                    {this.state.fileType === "textFile" && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="hasHeader">Has Header</label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormSelect
                            id="fileType"
                            onChange={this.onChangeHasHeader}
                            value={this.state.hasHeader}
                          >
                            <option value="true">True</option>
                            <option value="false">False</option>
                          </FormSelect>
                        </Col>
                      </Row>
                    )}

                    {showSupplierCodeIndex && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="supplierCode">Supplier Code</label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInput
                            id="supplierCode"
                            placeholder="Supplier Code"
                            value={this.state.supplierCode}
                            onChange={this.onChangeSupplierCode}
                          />
                        </Col>
                      </Row>
                    )}

                    {showStartDateIndex && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="StartDate">Start Date</label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInput
                            id="startDate"
                            placeholder="Start Date"
                            value={this.state.startDate}
                            onChange={this.onChangeStartDate}
                          />
                        </Col>
                      </Row>
                    )}

                    {showEndDateIndex && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="endDate">End Date</label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInput
                            id="endDate"
                            placeholder="End Date"
                            value={this.state.endDate}
                            onChange={this.onChangeEndDate}
                          />
                        </Col>
                      </Row>
                    )}

                    {INDIA && showSupplierName && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="supplierNameRow">
                            Supplier Name Row
                          </label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInput
                            id="supplierNameRow"
                            placeholder="Supplier Name Row"
                            value={this.state.supplierNameRow}
                            onChange={this.onChangeSupplierNameRow}
                          />
                        </Col>
                      </Row>
                    )}

                    {INDIA && showSupplierStatmentPeriodRow && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="supplierStatmentPeriodRow">
                            Supplier Statement period Row
                          </label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInput
                            id="supplierStatmentPeriodRow"
                            placeholder="Supplier Statement period Row"
                            value={this.state.supplierStatmentPeriodRow}
                            onChange={this.onChangeSupplierStatmentPeriodRow}
                          />
                        </Col>
                      </Row>
                    )}

                    {INDIA && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="compnayNameInColumns">
                            Company Name In Columns
                          </label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormSelect
                            id="fileType"
                            onChange={this.onChangeCompanyNameInColumns}
                            value={this.state.companyNameInColumns}
                          >
                            <option value="true">True</option>
                            <option value="false">False</option>
                          </FormSelect>
                        </Col>
                      </Row>
                    )}

                    {INDIA && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="compnayNameInColumns">
                            Company Name In Rows
                          </label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormSelect
                            id="fileType"
                            onChange={this.onChangeCompanyNameInRows}
                            value={this.state.companyNameInRows}
                          >
                            <option value="false">False</option>
                            <option value="true">True</option>
                          </FormSelect>
                        </Col>
                      </Row>
                    )}

                    {this.state.companyNameInRows && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="companyNameRowsCount">
                            Count of Text in Row to be Excluded
                          </label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInput
                            id="companyNameRowsCount"
                            placeholder="Count of Text in Row to be Excluded"
                            value={this.state.companyNameRowsCount}
                            onChange={this.onChangeCompanyNameRowsCount}
                          />
                        </Col>
                      </Row>
                    )}

                    {showSkipRows && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="skipRows">Skip Rows</label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInput
                            id="skipRows"
                            placeholder="Skip Rows"
                            value={this.state.skipRows}
                            onChange={this.onChangeSkipRows}
                          />
                        </Col>
                      </Row>
                    )}

                    {shoDataHeaderRow && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="dataHeaderRow">Data Header Row</label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInput
                            id="dataHeaderRow"
                            placeholder="Data Header Row"
                            value={this.state.dataHeaderRow}
                            onChange={this.onChangeDataHeaderRow}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="mergedColumns">Merged Columns</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormInput
                          id="mergedColumns"
                          placeholder="Merged Columns"
                          value={this.state.mergedCell}
                          onChange={this.onChangeMergedColumns}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="validationColumn">
                          Validation Column
                        </label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormInput
                          id="validationColumn"
                          placeholder="Validation Column"
                          value={this.state.validationColumn}
                          onChange={this.onChangeValidationColumn}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="exceptionKeywords">
                          Exception Keywords
                        </label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormTextarea
                          id="exceptionKeywords"
                          placeholder="Exception Keywords"
                          rows="3"
                          value={this.state.exceptionKeywords}
                          onChange={this.onChangeExceptionKeywords}
                        />
                      </Col>
                    </Row>
                    {(SAUDI || EGYPT) && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="fileDateFormat">Select File Date Format</label></Col>
                        <Col className="form-field" md="8">
                          <FormSelect id="fileDateFormat" onChange={this.onChangeFileDateFormat} value={this.state.fileDateFormat}>
                            <option value="">Select</option>
                            <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                            <option value="DD-MM-YYYY">DD-MM-YYYY</option>
                            <option value="DD.MM.YYYY">DD.MM.YYYY</option>
                            <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                            <option value="MM-DD-YYYY">MM-DD-YYYY</option>
                            <option value="MM.DD.YYYY">MM.DD.YYYY</option>
                            <option value="DD-MMM-YY">DD-MMM-YY</option>
                            <option value="DD-MMM-YYYY">DD-MMM-YYYY</option>
                            <option value="DD MMMM YYYY">DD MMMM YYYY</option>
                            <option value="YYYY-DD-MM">YYYY-DD-MM</option>
                            <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                            <option value="YYYYMMDD">YYYYMMDD</option>
                            <option value="YYYYMM">YYYYMM</option>
                            <option value="MMMM YYYY">MMMM YYYY</option>
                          </FormSelect>
                        </Col>
                      </Row>
                    )}
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">Select File</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <div className="custom-file mb-3">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="file"
                            name="file"
                            placeholder="Upload your excel file"
                            onChange={this.readFile.bind(this)}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="customFile2"
                          >
                            Choose file...
                          </label>
                        </div>

                        {projectStructureId && (
                          <div>
                            <FcApproval /> Uploaded Name : {fileName}
                          </div>
                        )}
                        {fileUploaded && (
                          <div>
                            <FcApproval /> File Name : {file && file.name}
                          </div>
                        )}
                      </Col>
                    </Row>
                    {INDIA && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="supplierName">Supplier Name</label>
                        </Col>
                        <Col className="form-field" md="8">
                          {this.state.supplierName}
                        </Col>
                      </Row>
                      )}
                    {INDIA && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="supplierName">Report Date Range </label>
                        </Col>
                        <Col className="form-field" md="8">
                          {this.state.reportPeriodRange &&
                            this.state.reportPeriodRange.join(" To ")}
                        </Col>
                      </Row>
                    )}
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="joinColumns">Remove & Replace String</label></Col>
                      <Col className="form-field" md="8">
                        {allColumnsArray && (
                          <Select
                            value={selectedAllColumnsArray}
                            onChange={this.handleSelectedAllColumnsArrayChange}
                            options={allColumnsArray}
                            isMulti={true}
                            defaultValue={selectedAllColumnsArray}
                          />
                          )}
                        <br />
                        <Row>
                          <Col>
                            <FormInput
                              id="selectedAllColumns"
                              placeholder="Enter Remove String"
                              value={this.state.selectedAllColumns}
                              onChange={this.onChangeSelectedAllColumns}
                            />
                          </Col>
                          <Col>
                            <FormInput
                              id="selectedAllReplaceColumns"
                              placeholder="Enter Replace String"
                              value={this.state.selectedAllReplaceColumns}
                              onChange={this.onChangeSelectedAllReplaceColumns}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {INDIA && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="isStripType">is Strip Type</label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormSelect
                            id="compnayNameInRows"
                            onChange={this.onChangeIsStripType}
                            value={this.state.isStripType}
                          >
                            <option value="false">False</option>
                            <option value="true">True</option>
                          </FormSelect>
                        </Col>
                      </Row>
                    )}
                    <Row className="form-group-row">
                      <Col className="form-field font-bold" md="12">
                        <label htmlFor="feFirstName">
                          Source Target Column Mapping
                        </label>
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col
                        className="form-label"
                        md="1"
                        style={{ maxWidth: "5%" }}
                      >
                        <label htmlFor="source">Count</label>
                      </Col>
                      <Col className="form-label" md="3">
                        <label htmlFor="source">Source</label>
                      </Col>
                      <Col className="form-label" md="3">
                        <label htmlFor="target">
                          {this.state.fileType == "textFile"
                            ? "Target Index"
                            : this.state.fileType == "fixedLength"
                            ? "Start Index"
                            : "Target"}
                        </label>
                      </Col>
                      {this.state.fileType == "fixedLength" ? (
                        <>
                          <Col className="form-label" md="3">
                            <label htmlFor="columnLevelTransformation">
                              Total Index
                            </label>
                          </Col>
                          <Col
                            className="form-label"
                            md="2"
                            style={{ maxWidth: "20%", flex: "0 0 20%" }}
                          >
                            <label htmlFor="columnLevelTransformation">
                              Column Level Transformation
                            </label>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col className="form-label" md="3">
                            <label htmlFor="columnLevelTransformation">
                              Column Level Transformation
                            </label>
                          </Col>
                          <Col
                            className="form-label"
                            md="2"
                            style={{ maxWidth: "20%", flex: "0 0 20%" }}
                          >
                            <label htmlFor="computedColumn">
                              Computed Column
                            </label>
                          </Col>
                        </>
                      )}
                    </Row>
                    {masterTableFieldInitial &&
                      masterTableFieldInitial.map((mitem, mindex) => {
                        return projectStructureId ? (
                          <Row className="form-group-row" key={mindex + 1}>
                            <Col
                              className="form-label"
                              md="1"
                              style={{ maxWidth: "5%" }}
                            >
                              <FormCheckbox
                                key={mindex + 1}
                                className="mb-1"
                                name={"count_" + mitem.fieldName}
                                id={"count_" + mitem.fieldName}
                                checked={mitem.checked}
                                onChange={(e) =>
                                  this.handleFieldCount(e, mitem.fieldName)
                                }
                              />
                            </Col>
                            <Col className="form-label" md="3">
                              <label htmlFor="feFirstName">
                                {mitem.fieldName}
                              </label>
                            </Col>
                            <Col className="form-field" md="3">
                              {fileUploaded ? ( // if previously uploaded
                                <>
                                  {fileType === "fixedLength" ? (
                                    <FormInput
                                      id={
                                        mitem.fieldName +
                                        mitem.mindex +
                                        "_startIndexText"
                                      }
                                      name={mitem.fieldName}
                                      placeholder={"Enter Start Index"}
                                      value={mitem.startIndex || ""}
                                      onChange={(e) =>
                                        this.onChangeStartIndex(
                                          e,
                                          mitem.fieldName
                                        )
                                      }
                                    />
                                  ) : (
                                    <FormSelect
                                      name={mitem.source || mitem.fieldName}
                                      id={mitem.source || mitem.fieldName}
                                      onChange={this.handleHeaderChange.bind(
                                        this
                                      )}
                                    >
                                      <option>Select Target Field</option>
                                      {headers &&
                                        headers.length &&
                                        headers.map(function (items, index) {
                                          if (items.toString() === mitem.target)
                                            return (
                                              <option
                                                key={mindex + index}
                                                value={mitem.target}
                                                selected
                                              >
                                                {mitem.target}
                                              </option>
                                            );
                                          else
                                            return (
                                              <option
                                                key={mindex + index}
                                                value={items}
                                              >
                                                {items}
                                              </option>
                                            );
                                        })}
                                    </FormSelect>
                                  )}
                                </>
                              ) : (
                                <>
                                  {fileType === "fixedLength" ? (
                                    <FormInput
                                      id={
                                        mitem.fieldName +
                                        mitem.mindex +
                                        "_startIndexText"
                                      }
                                      name={mitem.fieldName}
                                      placeholder={"Enter Start Index"}
                                      value={mitem.startIndex}
                                      onChange={(e) =>
                                        this.onChangeStartIndex(
                                          e,
                                          mitem.fieldName
                                        )
                                      }
                                    />
                                  ) : (
                                    <FormSelect
                                      name={mitem.target}
                                      id={mitem.target}
                                      onChange={this.handleHeaderChange.bind(
                                        this
                                      )}
                                    >
                                      <option>Select Target Field</option>
                                      <option
                                        key={mindex + 1 + 10}
                                        value={mitem.target}
                                        selected
                                      >
                                        {mitem.target}
                                      </option>
                                    </FormSelect>
                                  )}
                                </>
                              )}
                            </Col>

                            {fileType === "fixedLength" ? (
                              <Col className="form-field" md="3">
                                <FormInput
                                  id={
                                    mitem.fieldName +
                                    mitem.mindex +
                                    "_totalIndexText"
                                  }
                                  name={mitem.fieldName}
                                  placeholder={"Enter Total Index"}
                                  value={mitem.totalIndex || ""}
                                  onChange={(e) =>
                                    this.onChangeTotalIndex(e, mitem.fieldName)
                                  }
                                />
                              </Col>
                            ) : null}

                            <Col
                              className="form-field"
                              md={fileType === "fixedLength" ? "2" : "3"}
                            >
                              {/* {fileType === "fixedLength" ? (
                                <FormInput
                                  id={mitem.fieldName + mitem.mindex +"_totalIndexText"}
                                  name={mitem.fieldName}
                                  placeholder={"Enter Total Index"}
                                  value={mitem.totalIndex || ""}
                                  onChange={(e) => this.onChangeTotalIndex(e, mitem.fieldName)}
                                />
                              ): ( */}
                              <>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                  <FormSelect
                                    name={
                                      mindex + "_" + mitem.id + "_transformType"
                                    }
                                    id={
                                      mindex + "_" + mitem._id + "_transformType"
                                    }
                                    onChange={(e) =>
                                      this.colTransformFunctionChange(
                                        e,
                                        mitem.fieldName
                                      )
                                    }
                                    value={
                                      mitem.transformFunction
                                        ? mitem.transformFunction.id
                                        : ""
                                    }
                                  >
                                    <option>Select</option>
                                    {functionsList &&
                                      functionsList.map((item, index) => {
                                        return (
                                          <option key={index + 1} value={item.id}>
                                            {item.functionName}
                                          </option>
                                        );
                                      })}
                                  </FormSelect>
                                  <button
                                    type="button"
                                    onClick={(e) =>
                                      this.addAdditionalField(
                                        e,
                                        mitem.fieldName
                                      )
                                    }
                                    className="btn btn-primary"
                                  >
                                    +
                                  </button>
                                </div>
                                {mitem.transformFunction &&
                                mitem.transformFunction.parameters &&
                                mitem.transformFunction.parameters.length
                                  ? mitem.transformFunction.parameters.map(
                                      (prtm, findex) => {
                                        return (
                                          <div key={findex + "_transformWrap"}>
                                            {prtm.source === "FieldName" && (
                                              <FormSelect
                                                className="mt-3"
                                                name={prtm.parameterName}
                                                id={prtm._id + "_transformType"}
                                                onChange={(e) =>
                                                  this.transFuncParamValChanged(
                                                    e,
                                                    mitem.fieldName,
                                                    prtm._id
                                                  )
                                                }
                                                value={prtm.sourceField || ""}
                                              >
                                                <option>
                                                  Select Parameter for{" "}
                                                  {prtm.parameterName}
                                                </option>
                                                {headers &&
                                                headers.length > 0 ? (
                                                  headers.map(
                                                    (foitem, foindex) => {
                                                      return (
                                                        <option
                                                          key={foindex + 1}
                                                          value={foitem}
                                                        >
                                                          {foitem}
                                                        </option>
                                                      );
                                                    }
                                                  )
                                                ) : (
                                                  <option
                                                    key={prtm._id + 1}
                                                    value={prtm.sourceField}
                                                  >
                                                    {prtm.sourceField}
                                                  </option>
                                                )}
                                              </FormSelect>
                                            )}
                                            {prtm.source === "MasterFieldName" && (
                                              <FormSelect className="mt-3" name={prtm.parameterName} id={prtm._id+"_transformType"}
                                                onChange={(e) => this.transFuncParamValChanged(e, mitem.fieldName, prtm._id)}
                                                value={prtm.sourceField || ""}>
                                                <option>Select Parameter for {prtm.parameterName}</option>
                                                {masterTableFields && masterTableFields.length > 0 ? masterTableFields.map(
                                                    (foitem, foindex) => {
                                                      return <option key={foindex+1} value={foitem.apiKey}>{foitem.fieldName}</option>
                                                    }) : 
                                                  (<option key={prtm._id+1} value={prtm.sourceField}>{prtm.sourceField}</option>)
                                                }
                                              </FormSelect>
                                            )}
                                            {prtm.source == "CustomValue" && (
                                              <FormInput
                                                id={prtm + "_transformText"}
                                                name={prtm.parameterName}
                                                placeholder={
                                                  "Enter value for " +
                                                  prtm.parameterName
                                                }
                                                className="mt-3"
                                                value={prtm.inputValue || ""}
                                                onChange={(e) =>
                                                  this.transFuncParamValChanged(
                                                    e,
                                                    mitem.fieldName,
                                                    prtm._id
                                                  )
                                                }
                                              />
                                            )}
                                          </div>
                                        );
                                      }
                                    )
                                  : null}
                              </>
                              {/* )} */}
                            </Col>
                          </Row>
                        ) : (
                          <Row className="form-group-row" key={mindex + 1}>
                            <Col
                              className="form-label"
                              md="1"
                              style={{ maxWidth: "5%" }}
                            >
                              <FormCheckbox
                                key={mindex + 1}
                                className="mb-1"
                                name={"count_" + mitem.fieldName}
                                id={"count_" + mitem.fieldName}
                                checked={mitem.checked}
                                onChange={(e) =>
                                  this.handleFieldCount(e, mitem.fieldName)
                                }
                              />
                              {/* <FormCheckbox key={mindex+1} className="mb-1" name={"count_"+mitem.source} defaultValue={this.state.fieldCount} id={"count_"+mitem.source} onChange={this.handleFieldCount.bind(this)}></FormCheckbox> */}
                            </Col>

                            <Col className="form-label" md="3">
                              <label htmlFor="fieldName">
                                {mitem.fieldName}
                              </label>
                            </Col>
                            {this.state.fileType === "fixedLength" ? (
                              <Col className="form-field" md="3">
                                <FormInput
                                  id={
                                    mitem.fieldName +
                                    mitem.mindex +
                                    "_startIndexText"
                                  }
                                  name={mitem.fieldName}
                                  placeholder={"Enter Start Index"}
                                  value={mitem.startIndex || ""}
                                  onChange={(e) =>
                                    this.onChangeStartIndex(e, mitem.fieldName)
                                  }
                                />
                              </Col>
                            ) : (
                              <Col className="form-field" md="3">
                                <FormSelect
                                  name={mitem.fieldName}
                                  id={mitem.fieldName}
                                  onChange={this.handleHeaderChange.bind(this)}
                                >
                                  <option>Select Target Field</option>
                                  {headers &&
                                    headers.length &&
                                    headers.map((items, index) => {
                                      return (
                                        <option
                                          key={mindex + index}
                                          value={items}
                                        >
                                          {items}
                                        </option>
                                      );
                                    })}
                                </FormSelect>
                              </Col>
                            )}

                            {this.state.fileType === "fixedLength" ? (
                              <Col className="form-field" md="3">
                                <FormInput
                                  id={
                                    mitem.fieldName +
                                    mitem.mindex +
                                    "_totalIndexText"
                                  }
                                  name={mitem.fieldName}
                                  placeholder={"Enter Total Index"}
                                  value={mitem.totalIndex || ""}
                                  onChange={(e) =>
                                    this.onChangeTotalIndex(e, mitem.fieldName)
                                  }
                                />
                              </Col>
                            ) : null}

                            <Col className="form-field" md="2">
                              <FormSelect
                                name={
                                  mindex + "_" + mitem.id + "_transformType"
                                }
                                id={mindex + "_" + mitem._id + "_transformType"}
                                onChange={(e) =>
                                  this.colTransformFunctionChange(
                                    e,
                                    mitem.fieldName
                                  )
                                }
                                value={
                                  mitem.transformFunction
                                    ? mitem.transformFunction.id
                                    : ""
                                }
                              >
                                <option>Select</option>
                                {functionsList &&
                                  functionsList.map((item, index) => {
                                    return (
                                      <option key={index + 1} value={item.id}>
                                        {item.functionName}
                                      </option>
                                    );
                                  })}
                              </FormSelect>
                              <button
                                type="button"
                                onClick={(e) =>
                                  this.addAdditionalField(
                                    e,
                                    mitem.fieldName
                                  )
                                }
                                className="btn btn-primary"
                              >
                                +
                              </button>
                              {mitem.transformFunction &&
                              mitem.transformFunction.parameters &&
                              mitem.transformFunction.parameters.length
                                ? mitem.transformFunction.parameters.map(
                                    (prtm, findex) => {
                                      return (
                                        <div key={findex + "_transformWrap"}>
                                          {prtm.source === "FieldName" && (
                                            <FormSelect
                                              className="mt-3"
                                              name={prtm.parameterName}
                                              id={prtm._id + "_transformType"}
                                              onChange={(e) =>
                                                this.transFuncParamValChanged(
                                                  e,
                                                  mitem.fieldName,
                                                  prtm._id
                                                )
                                              }
                                              value={prtm.sourceField || ""}
                                            >
                                              <option>
                                                Select Parameter for{" "}
                                                {prtm.parameterName}
                                              </option>
                                              {headers && headers.length > 0 ? (
                                                headers.map(
                                                  (foitem, foindex) => {
                                                    return (
                                                      <option
                                                        key={foindex + 1}
                                                        value={foitem}
                                                      >
                                                        {foitem}
                                                      </option>
                                                    );
                                                  }
                                                )
                                              ) : (
                                                <option
                                                  key={prtm._id + 1}
                                                  value={prtm.sourceField}
                                                >
                                                  {prtm.sourceField}
                                                </option>
                                              )}
                                            </FormSelect>
                                          )}
                                          {prtm.source === "MasterFieldName" && (
                                              <FormSelect className="mt-3" name={prtm.parameterName} id={prtm._id+"_transformType"}
                                                onChange={(e) => this.transFuncParamValChanged(e, mitem.fieldName, prtm._id)}
                                                value={prtm.sourceField || ""}>
                                                <option>Select Parameter for {prtm.parameterName}</option>
                                                {masterTableFields && masterTableFields.length > 0 ? masterTableFields.map(
                                                    (foitem, foindex) => {
                                                      return <option key={foindex+1} value={foitem.apiKey}>{foitem.fieldName}</option>
                                                    }) : 
                                                  (<option key={prtm._id+1} value={prtm.sourceField}>{prtm.sourceField}</option>)
                                                }
                                              </FormSelect>
                                            )}
                                          {prtm.source == "CustomValue" && (
                                            <FormInput
                                              id={prtm + "_transformText"}
                                              name={prtm.parameterName}
                                              placeholder={
                                                "Enter value for " +
                                                prtm.parameterName
                                              }
                                              className="mt-3"
                                              value={prtm.inputValue || ""}
                                              onChange={(e) =>
                                                this.transFuncParamValChanged(
                                                  e,
                                                  mitem.fieldName,
                                                  prtm._id
                                                )
                                              }
                                            />
                                          )}
                                        </div>
                                      );
                                    }
                                  )
                                : null}
                            </Col>
                          </Row>
                        );
                      })}

                    <Row className="form-group-row">
                      <Col className="form-button" md="4">
                        <Button 
                          className="btn btn-primary float-left mr-3"
                          onClick={() => this.viewOriginalFile(this.state.file)}
                          theme="accent"
                        >
                          <FcDataConfiguration /> Test Run
                        </Button>
                        <Button
                          className="btn btn-primary float-left mr-3"
                          onClick={() => {
                            this.viewOriginalFile(
                              this.state.file,
                              "testrunwithsp"
                            );
                          }}
                          theme="accent"
                        >
                          <FcDataConfiguration /> Test Run With SP Function
                        </Button>
                        {SPAIN && (
                          <Button className="btn btn-primary float-left mr-3 mt-4" onClick={() => {this.addAdditionalItem();}} theme="accent"><FcDataConfiguration /> Add Additional Column</Button>
                        )}
                      </Col>
                      <Col className="form-button" md="4">
                        {`Total Rows Count: ${totalRowCount}`}
                        <br />
                        {`Total Empty Rows Count: ${totalEmptyRowCount}`}
                        <br />
                        {`Total Rows processed: ${totalRowProcessed}`}
                        <br />
                        {`Total Error Rows: ${totalErrorRow}`}
                      </Col>
                      <Col className="form-button" md="4">
                        {projectStructureId ? (
                          cloneText ? (
                            <Button
                              variant="primary"
                              className="float-left mr-3"
                              onClick={this.handleCloneProjectStructureForm}
                            >
                              <FcPlus /> Clone Structure
                            </Button>
                          ) : (
                            <Button
                              variant="primary"
                              className="float-left mr-3"
                              onClick={this.handleUpdateProjectStructureForm}
                            >
                              <FcPlus /> Update Structure
                            </Button>
                          )
                        ) : (
                          showSaveBtn && (
                            <Button
                              variant="primary"
                              className="float-left mr-3"
                              onClick={this.handleAddProjectStructureForm}
                            >
                              <FcPlus /> Save Structure
                            </Button>
                          )
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
              {viewTable && (
                <>
                  <Container>
                    <Row>
                      <TableColumnRow
                        rows={this.state.columnsRows}
                        headers={this.state.headers}
                        clearData={clearData}
                      />
                    </Row>
                  </Container>

                  <Container>
                    <Row>
                      <TableRow rows={this.state.rows} clearData={clearData} />
                    </Row>
                  </Container>
                </>
              )}
            </ListGroupItem>
          </ListGroup>
          <ToastContainer />
        </Card>
      </div>
    );
  }
}

export default CreateProjectStructure;
